var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFsxDndSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41 41",
    style: {
      enableBackground: "new 0 0 41 41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.fsx-dnd-small{fill:#FFFFFF;stroke:#E8E8E8;}\n\t.fsx-dnd-small-1{fill:#1FA0FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ic_sync_cvs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    className: "fsx-dnd-small",
    cx: 20.5,
    cy: 20.5,
    r: 20
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Product-Icon_FSx-for-NetApp_150x100",
    className: "fsx-dnd-small-1",
    d: "M31.2,24.6l-0.1-0.6c0.4,0,0.7-0.4,0.7-0.8c0-0.4-0.3-0.8-0.7-0.8 c-0.2,0-0.3-0.2-0.3-0.4c0-0.2-0.1-0.4-0.3-0.4c-0.1,0-0.3,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.2-0.2 c-0.1-0.2-0.2-0.4-0.4-0.6c-0.4-0.4-0.9-0.5-1.4-0.3c-0.4,0.2-0.7,0.6-0.7,1.1c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.3-0.2,0.3 c-0.4,0.1-0.6,0.4-0.6,0.8c0,0,0,0.1,0,0.1c0.1,0.4,0.4,0.7,0.8,0.7v0.6c-0.8,0-1.4-0.6-1.4-1.4c0,0,0,0,0,0v0 c0-0.6,0.3-1.1,0.8-1.3c0-0.7,0.4-1.4,1.1-1.7c0.7-0.3,1.5-0.2,2.1,0.4c0.1,0.1,0.2,0.3,0.3,0.4c0.2-0.1,0.4-0.1,0.6-0.1 c0.4,0.1,0.6,0.4,0.7,0.8c0.6,0.2,1,0.7,1,1.4C32.5,23.9,31.9,24.5,31.2,24.6L31.2,24.6z M8.5,25.1h0.8v-4.3H13V20H9.3v-3.6h4.4 v-0.7H8.5L8.5,25.1z M19.8,21.3c0.3,0.4,0.5,0.9,0.4,1.4c0,0.7-0.3,1.5-0.9,1.9c-0.7,0.5-1.5,0.8-2.3,0.7c-0.9,0-1.8-0.2-2.7-0.6 V24c0.8,0.3,1.7,0.5,2.6,0.5c0.6,0,1.3-0.2,1.8-0.5c0.4-0.3,0.7-0.9,0.7-1.4c0-0.4-0.1-0.7-0.4-0.9c-0.3-0.3-0.7-0.6-1.2-0.7 l-1.6-0.6c-0.6-0.2-1.1-0.5-1.5-1c-0.3-0.4-0.5-0.9-0.5-1.4c0-0.7,0.3-1.4,0.8-1.8c0.6-0.5,1.3-0.7,2.1-0.7c0.4,0,0.8,0,1.2,0.1 c0.4,0.1,0.8,0.2,1.2,0.4v0.7c-0.8-0.3-1.6-0.5-2.4-0.5c-0.6,0-1.1,0.1-1.6,0.5c-0.4,0.3-0.6,0.8-0.6,1.3c0,0.3,0,0.5,0.2,0.8 c0.1,0.2,0.3,0.4,0.5,0.5c0.3,0.2,0.7,0.4,1.1,0.5l1.4,0.6C18.9,20.5,19.4,20.8,19.8,21.3L19.8,21.3z M23.1,20.5l-2.1-3H22l1.6,2.3 L23.1,20.5z M24.6,21.1l0.9,1.2c-0.2,0.3-0.3,0.7-0.4,1.1l-1.5-2.2l0.5-0.8l2-2.9h1.1L24.6,21.1z M23.1,21.8l0.5,0.7l-1.8,2.6h-1.1 L23.1,21.8z M30,26c0.1,0,0.2-0.2,0.2-0.3V23c0-0.2-0.1-0.3-0.3-0.3s-0.3,0.1-0.3,0.3c0,0,0,0,0,0v1.6l-1.1-1.8 c-0.1-0.1-0.3-0.2-0.4-0.1c-0.1,0.1-0.1,0.2-0.1,0.3v2.7c0,0.2,0.2,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.3v-1.6l1.1,1.8 C29.7,26,29.8,26,30,26C30,26,30,26,30,26L30,26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsxDndSmall);
export default __webpack_public_path__ + "static/media/fsx-dnd-small.a77ffd4779032edbda2e6b3312948f7e.svg";
export { ForwardRef as ReactComponent };